import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import { useKeywordsPageContext } from 'pages/keywords/context'
import { KeywordsList } from './KeywordsList'

export const AllKeywords = observer(() => {
  const { setIsKeywordsActionShown } = useKeywordsPageContext()

  return (
    <FullPageWrapper>
      <KeywordsList setIsKeywordsActionShown={setIsKeywordsActionShown} />
    </FullPageWrapper>
  )
})
